import { useParams } from "react-router";
import { services } from "../../data/services";
import { motion } from "framer-motion";

export default function ServiceDetail(): JSX.Element {
  const { slug } = useParams() as { slug?: string };
  const service = services.find((s) => s.slug === slug);

  if (!service) {
    return (
      <div className="max-w-5xl mx-auto p-6 text-center">
        <h1 className="text-2xl font-bold text-red-600">Service Not Found</h1>
        <p className="text-gray-600 mt-2">
          The service you are looking for does not exist.
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto p-6">
      <motion.h1
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-3xl font-bold text-indigo-600 mb-4 bg-white/90 backdrop-blur-sm z-10"
      >
        {service.title}
      </motion.h1>

      <div className="relative w-full h-[500px] rounded-2xl shadow-md overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center blur-2xl scale-110"
          style={{ backgroundImage: `url(${service.image})` }}
        />
        <div className="absolute inset-0 bg-white/10 backdrop-blur-md" />
        <motion.img
          src={service.image}
          alt={service.title}
          className="relative z-10 w-full h-full object-contain"
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        />
      </div>

      <motion.p
        className="text-gray-700 leading-relaxed"
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6, ease: "easeOut" }}
      >
        {service.description}
      </motion.p>
    </div>
  );
}
